import Root from './components/Root';

export default {
    Root,
};



// WEBPACK FOOTER //
// ./hypernova.js